// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Agenda from "./agenda.js"
import AgendaItemElement from "./agenda-item-element.js"

const modelClassData = {
  "attributes": {
    "agenda_item_elements_count": {
      "column": {
        "default": 0,
        "name": "agenda_item_elements_count",
        "null": false,
        "type": "integer"
      },
      "name": "agenda_item_elements_count",
      "selected_by_default": null,
      "translated": null
    },
    "agenda_id": {
      "column": {
        "default": null,
        "name": "agenda_id",
        "null": false,
        "type": "uuid"
      },
      "name": "agenda_id",
      "selected_by_default": null,
      "translated": null
    },
    "children_count": {
      "column": {
        "default": 0,
        "name": "children_count",
        "null": false,
        "type": "integer"
      },
      "name": "children_count",
      "selected_by_default": null,
      "translated": null
    },
    "ends_at": {
      "column": {
        "default": null,
        "name": "ends_at",
        "null": true,
        "type": "time"
      },
      "name": "ends_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "parent_id": {
      "column": {
        "default": null,
        "name": "parent_id",
        "null": true,
        "type": "uuid"
      },
      "name": "parent_id",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "show_in_live": {
      "column": {
        "default": false,
        "name": "show_in_live",
        "null": false,
        "type": "boolean"
      },
      "name": "show_in_live",
      "selected_by_default": null,
      "translated": null
    },
    "starts_at": {
      "column": {
        "default": null,
        "name": "starts_at",
        "null": true,
        "type": "time"
      },
      "name": "starts_at",
      "selected_by_default": null,
      "translated": null
    },
    "any_children_shown_in_live": {
      "column": null,
      "name": "any_children_shown_in_live",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "AgendaItem",
  "collectionKey": "agenda_items",
  "collectionName": "agenda_items",
  "i18nKey": "agenda_item",
  "camelizedLower": "agendaItem",
  "name": "AgendaItem",
  "nameDasherized": "agenda-item",
  "pluralName": "agenda_items",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "has_one",
      "resource_name": "Activity",
      "through": "agenda"
    },
    {
      "className": "Agenda",
      "collectionName": "agendas",
      "foreignKey": "agenda_id",
      "name": "agenda",
      "macro": "belongs_to",
      "resource_name": "Agenda",
      "through": null
    },
    {
      "className": "AgendaItemElement",
      "collectionName": "agenda_item_elements",
      "foreignKey": "agenda_item_id",
      "name": "agenda_item_elements",
      "macro": "has_many",
      "resource_name": "AgendaItemElement",
      "through": null
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "parent_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "AgendaItem",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "current_agenda_item_id",
      "name": "current_for_activities",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "parent_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "AgendaItem",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "agenda_id",
      "column": {
        "default": null,
        "name": "agenda_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "agenda_item_elements_count",
      "column": {
        "default": 0,
        "name": "agenda_item_elements_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "children_count",
      "column": {
        "default": 0,
        "name": "children_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "depth",
      "column": {
        "default": 0,
        "name": "depth",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "ends_at",
      "column": {
        "default": null,
        "name": "ends_at",
        "null": true,
        "type": "time"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "lft",
      "column": {
        "default": null,
        "name": "lft",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_agenda_id",
      "column": {
        "default": null,
        "name": "old_agenda_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_parent_id",
      "column": {
        "default": null,
        "name": "old_parent_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "parent_id",
      "column": {
        "default": null,
        "name": "parent_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "rgt",
      "column": {
        "default": null,
        "name": "rgt",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "show_in_live",
      "column": {
        "default": false,
        "name": "show_in_live",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "starts_at",
      "column": {
        "default": null,
        "name": "starts_at",
        "null": true,
        "type": "time"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Agenda",
      "collectionName": "agendas",
      "foreignKey": "agenda_id",
      "name": "agenda",
      "macro": "belongs_to",
      "resource_name": "Agenda",
      "through": null
    },
    {
      "className": "AgendaItemElement",
      "collectionName": "agenda_item_elements",
      "foreignKey": "agenda_item_id",
      "name": "agenda_item_elements",
      "macro": "has_many",
      "resource_name": "AgendaItemElement",
      "through": null
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "parent_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "AgendaItem",
      "through": null
    }
  ],
  "paramKey": "agenda_item",
  "primaryKey": "id"
}

/** Frontend model for AgendaItem. */
export default class AgendaItem extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number} */
  agendaItemElementsCount() {
    return this.readAttributeUnderscore("agenda_item_elements_count")
  }

  /** @returns {boolean} */
  hasAgendaItemElementsCount() {
    const value = this.agendaItemElementsCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  agendaId() {
    return this.readAttributeUnderscore("agenda_id")
  }

  /** @returns {boolean} */
  hasAgendaId() {
    const value = this.agendaId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  childrenCount() {
    return this.readAttributeUnderscore("children_count")
  }

  /** @returns {boolean} */
  hasChildrenCount() {
    const value = this.childrenCount()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  endsAt() {
    return this.readAttributeUnderscore("ends_at")
  }

  /** @returns {boolean} */
  hasEndsAt() {
    const value = this.endsAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  parentId() {
    return this.readAttributeUnderscore("parent_id")
  }

  /** @returns {boolean} */
  hasParentId() {
    const value = this.parentId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  showInLive() {
    return this.readAttributeUnderscore("show_in_live")
  }

  /** @returns {boolean} */
  hasShowInLive() {
    const value = this.showInLive()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  startsAt() {
    return this.readAttributeUnderscore("starts_at")
  }

  /** @returns {boolean} */
  hasStartsAt() {
    const value = this.startsAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  anyChildrenShownInLive() {
    return this.readAttributeUnderscore("any_children_shown_in_live")
  }

  /** @returns {boolean} */
  hasAnyChildrenShownInLive() {
    const value = this.anyChildrenShownInLive()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  ancestors(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "ancestors",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_items",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./agenda.js").default | null} */
  agenda() {
    return this._readBelongsToReflection({modelClass: Agenda, reflectionName: "agenda"})
  }

  /** @returns {Promise<import("./agenda.js").default | null>} */
  loadAgenda() {
    if (!("agendaId" in this)) throw new Error("Foreign key method wasn't defined: agendaId")

    const id = this.agendaId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "agenda",
        model: this,
        modelClass: Agenda
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./agenda.js").default | null>} */
  ensureAgendaLoaded() {
    return this.ensureAssociationLoaded("agenda")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./agenda-item-element.js").default>} */
  agendaItemElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["agenda_item_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "agenda_item_elements",
        model: this,
        modelClass: AgendaItemElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./agenda-item-element.js").default>>} */
  loadAgendaItemElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["agenda_item_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "agenda_item_elements",
        model: this,
        modelClass: AgendaItemElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./agenda-item-element.js").default>>} */
  ensureAgendaItemElementsLoaded() {
    return this.ensureAssociationLoaded("agenda_item_elements")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./agenda-item.js").default>} */
  children() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "children",
        model: this,
        modelClass: AgendaItem
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./agenda-item.js").default>>} */
  loadChildren() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["parent_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "children",
        model: this,
        modelClass: AgendaItem
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./agenda-item.js").default>>} */
  ensureChildrenLoaded() {
    return this.ensureAssociationLoaded("children")
  }
}
